import { z } from 'zod';
import { paginationQuery } from './common.js';
import { companyBase } from './company.js';
import { appModuleKey, companyPlan, roleKey, } from './permissions.js';
export const adminCompanyInput = companyBase.extend({
    plan: companyPlan.default('full'),
    ownerEmail: z.email('Correo inválido').trim().toLowerCase(),
    ownerName: z.string().trim().min(2, 'Requerido').max(120),
    /** Módulos opcionales con los que nace la compañía (los core siempre están). */
    modules: z.array(appModuleKey).default([]),
});
export const adminListQuery = paginationQuery.extend({
    status: z.enum(['active', 'suspended', 'disabled']).optional(),
});
/** Da acceso a compañías con un rol: a las indicadas, o a todas las existentes (`allCompanies`). */
export const adminAccessInput = z
    .object({
    role: roleKey,
    companyIds: z.array(z.uuid()).default([]),
    allCompanies: z.boolean().default(false),
})
    .refine((v) => v.allCompanies || v.companyIds.length > 0, {
    message: 'Elegí al menos una compañía',
    path: ['companyIds'],
});
export const adminUserInput = z.object({
    email: z.email('Correo inválido').trim().toLowerCase(),
    name: z.string().trim().min(2, 'Requerido').max(120),
    isSuperadmin: z.boolean().default(false),
    /** Opcional: compañías a las que el usuario nuevo queda asignado al crearlo. */
    access: adminAccessInput.optional(),
});
export const adminUserUpdate = z.object({
    name: z.string().trim().min(2).max(120).optional(),
    status: z.enum(['active', 'disabled']).optional(),
    isSuperadmin: z.boolean().optional(),
});
/* ---------- Bitácora de auditoría ---------- */
export const auditListQuery = paginationQuery.extend({
    companyId: z.uuid().optional(),
    /** Acción exacta o prefijo (`auth`, `member.role_changed`). */
    action: z
        .string()
        .trim()
        .max(80)
        .regex(/^[a-z_.]*$/)
        .optional(),
});
export const adminMembershipUpdate = z.object({
    role: roleKey.optional(),
    status: z.enum(['active', 'disabled']).optional(),
});
/** Asigna varios usuarios existentes a una compañía con un mismo rol. */
export const adminCompanyMembersInput = z.object({
    userIds: z.array(z.uuid()).min(1, 'Elegí al menos un usuario'),
    role: roleKey,
});
/** Módulos opcionales activos de una compañía (los core no se listan: siempre están). */
export const adminCompanyModulesInput = z.object({ modules: z.array(appModuleKey) });
//# sourceMappingURL=admin.js.map